import { createFileRoute } from '@tanstack/react-router';
import { UnderConstruction } from '@/components/UnderConstruction';

export const Route = createFileRoute('/under-construction')({
  component: UnderConstructionPage,
});

function UnderConstructionPage() {
  return (
    <UnderConstruction
      title="Under Construction"
      message="This page is currently under construction. We're working hard to bring you something amazing. Please check back soon!"
      showHomeButton={true}
    />
  );
}
